import { Routes } from '@angular/router';
import {
  adminGuard,
  authGuard,
  completeRegistrationPageGuard,
  guestGuard,
  maintenanceGuard,
  pendingProfileGuard
} from './core';
import { articleResolver } from './features/blog/resolvers/article.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    canActivate: [maintenanceGuard, pendingProfileGuard],
    data: { title: 'Home', description: 'Benvenuto nella home' },
    pathMatch: 'full'
  },
  {
    path: 'maintenance',
    loadComponent: () => import('./features/maintenance/maintenance.component').then(m => m.MaintenanceComponent),
    data: { title: 'Manutenzione', description: 'Sito in manutenzione' }
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [guestGuard, maintenanceGuard],
    data: { title: 'Login', description: 'Accedi al tuo account' }
  },
  {
    path: 'completa-registrazione',
    loadComponent: () =>
      import('./features/auth/completa-registrazione/completa-registrazione.component').then(
        m => m.CompletaRegistrazioneComponent,
      ),
    canActivate: [maintenanceGuard, completeRegistrationPageGuard],
    data: { title: 'Completa registrazione', description: 'Nome, cognome e preferenze newsletter' }
  },
  {
    path: 'chi-siamo',
    loadComponent: () => import('./features/chi-siamo/chi-siamo.component').then(m => m.ChiSiamoComponent),
    canActivate: [maintenanceGuard, pendingProfileGuard],
    data: { title: 'Chi siamo', description: 'Scopri chi siamo' }
  },
  {
    path: 'contatti',
    loadComponent: () => import('./features/contatti/contatti.component').then(m => m.ContattiComponent),
    canActivate: [maintenanceGuard, pendingProfileGuard],
    data: { title: 'Contatti', description: 'Contattaci' }
  },
  {
    path: 'healt',
    loadComponent: () => import('./features/healt/healt.component').then(m => m.HealtComponent),
    canActivate: [maintenanceGuard, pendingProfileGuard],
    data: { title: 'Healt', description: 'Pagina di salute' }
  },
  {
    path: 'blog',
    loadComponent: () => import('./features/blog/blog.component').then(m => m.BlogComponent),
    canActivate: [maintenanceGuard, pendingProfileGuard],
    data: { title: 'Blog', description: 'Articoli su educazione finanziaria e investimenti' }
  },
  {
    path: 'blog/article/:slug',
    loadComponent: () => import('./features/blog/pages/article-detail/article-detail.component').then(m => m.ArticleDetailComponent),
    canActivate: [maintenanceGuard, pendingProfileGuard],
    resolve: {
      article: articleResolver
    },
    data: { title: 'Articolo', description: 'Dettaglio articolo del blog' }
  },
  {
    path: 'blog/article-preview/:slug',
    loadComponent: () => import('./features/blog/pages/article-detail/article-detail.component').then(m => m.ArticleDetailComponent),
    canActivate: [adminGuard],
    data: { title: 'Anteprima articolo', description: 'Anteprima articolo del blog' }
  },
  {
    path: 'backoffice',
    loadChildren: () => import('./features/backoffice/backoffice.routes').then(m => m.backofficeRoutes),
    data: { title: 'Backoffice', description: 'Area amministrativa' }
  },
  {
    path: 'calcolatori',
    loadChildren: () => import('./features/calcolatori/calcolatori.routes').then(m => m.calcolatoriRoutes),
    canActivate: [maintenanceGuard, authGuard],
    data: { title: 'Calcolatori', description: 'Calcolatori online' }
  },
  {
    path: 'profilo',
    loadChildren: () => import('./features/profilo/profilo.routes').then(m => m.profiloRoutes),
    canActivate: [maintenanceGuard, authGuard],
    data: { title: 'Profilo', description: 'Il tuo profilo utente' }
  },
  {
    path: 'calendario-economico',
    redirectTo: '/market-dashboard',
    pathMatch: 'full'
  },
  {
    path: 'market-dashboard',
    loadComponent: () => import('./features/profilo/pages/calendario-economico').then(m => m.CalendarioEconomicoComponent),
    canActivate: [maintenanceGuard, authGuard],
    data: { title: 'Market Dashboard', description: 'Eventi, notizie e dati di mercato in tempo reale' }
  },
  {
    path: 'post-instagram',
    loadComponent: () => import('./features/profilo/pages/instagram-posts/instagram-posts.component').then(m => m.InstagramPostsComponent),
    canActivate: [maintenanceGuard, authGuard],
    data: { title: 'Post Instagram', description: 'Tutti i post Instagram di DOPT' }
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
